import { AxiosError } from 'axios';
import { BaseError } from '@utils/types/shared/base.ts';

/** Every reason the API refuses a contribution, mapped to what the user can do
 * about it. Without this they all render as "Submission failed. Please try
 * again." — and for a model at its clip limit, or one that is mid-training,
 * trying again is exactly the wrong advice. Unknown codes keep the generic
 * message, so a new API error is never rendered as a blank line. */
const CONTRIBUTION_ERROR_MESSAGES: Record<string, string> = {
  'contribution-limit-reached': 'contribution-limit-reached',
  'duplicate-contribution': 'contribution-duplicate',
  'model-training-active': 'contribution-model-training',
  'language-mismatch': 'contribution-language-mismatch',
  'media-unavailable': 'contribution-media-unavailable',
  'window-too-long': 'training-window-too-long',
  'contribution-too-long': 'contribution-too-long'
};

export const contributionErrorKey = (
  error: AxiosError<BaseError> | null
): string => {
  const code = error?.response?.data?.error;
  return (code && CONTRIBUTION_ERROR_MESSAGES[code]) || 'contribution-failed';
};
